import React from 'react';

export const formatBetaDate = (dateStr) => {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const StatusBadge = ({ status }) => {
  const styles = {
    active: 'bg-green-500/20 text-green-400 border-green-500/30',
    used: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
    revoked: 'bg-red-500/20 text-red-400 border-red-500/30'
  };
  return <span className={`px-2 py-0.5 rounded-full text-xs font-medium border ${styles[status] || 'bg-gray-500/20 text-gray-400'}`}>{status}</span>;
};

const STATS_CARDS = [
  { key: 'total', path: 'codes.total', label: 'Total Codes', border: 'border-gray-700' },
  { key: 'available', path: 'codes.available', label: 'Available', border: 'border-green-800/40', color: 'text-green-400' },
  { key: 'used', path: 'codes.used', label: 'Used', border: 'border-blue-800/40', color: 'text-blue-400' },
  { key: 'revoked', path: 'codes.revoked', label: 'Revoked', border: 'border-red-800/40', color: 'text-red-400' },
];

const USER_CARDS = [
  { key: 'total', path: 'users.total', label: 'Total Beta Users', border: 'border-gray-700' },
  { key: 'active', path: 'users.active', label: 'Active Beta', border: 'border-emerald-800/40', color: 'text-emerald-400' },
  { key: 'expired', path: 'users.expired', label: 'Expired Beta', border: 'border-amber-800/40', color: 'text-amber-400' },
];

const getNestedValue = (obj, path) => path.split('.').reduce((o, k) => o?.[k], obj);

export const BetaStatsCards = ({ stats }) => {
  if (!stats) return null;
  return (
    <>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {STATS_CARDS.map(c => (
          <div key={c.key} className={`bg-gray-900 rounded-lg p-4 border ${c.border}`}>
            <div className={`text-2xl font-bold ${c.color || 'text-white'}`}>{getNestedValue(stats, c.path)}</div>
            <div className="text-xs text-gray-400 mt-1">{c.label}</div>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-3 gap-3">
        {USER_CARDS.map(c => (
          <div key={c.key} className={`bg-gray-900 rounded-lg p-4 border ${c.border}`}>
            <div className={`text-2xl font-bold ${c.color || 'text-white'}`}>{getNestedValue(stats, c.path)}</div>
            <div className="text-xs text-gray-400 mt-1">{c.label}</div>
          </div>
        ))}
      </div>
    </>
  );
};
